import type { ParsedInsightsFilters } from '@/lib/api/types/dashboard/filters';
import {
  transformCompactToDateFilter,
  transformCompactToPicklistFilter,
} from '@/lib/utils/compact-filters/transformCompactFilters';
import { getArrayValue, getDateFilterValue } from '@/lib/utils/filters/filterValueExtractors';
import { Route } from '@/routes/(app)/org/$org/loop/$loopId/dashboard/route';

export type { ParsedInsightsFilters } from '@/lib/api/types/dashboard/filters';

type InsightsSearch = ReturnType<typeof Route.useSearch>;

export const parseInsightsSortingFromSearch = (search: InsightsSearch): string | undefined => {
  if (!search.orderBy) return undefined;

  const direction = search.orderDir || 'asc';
  return `${search.orderBy} ${direction.toUpperCase()} nullsLast`;
};

const parseInsightsFiltersFromSearch = (search: InsightsSearch): ParsedInsightsFilters => {
  return {
    teamId: getArrayValue(transformCompactToPicklistFilter(search.teamId)),
    statusId: getArrayValue(transformCompactToPicklistFilter(search.statusId)),
    itemTypeId: getArrayValue(transformCompactToPicklistFilter(search.itemTypeId)),
    integrationId: getArrayValue(transformCompactToPicklistFilter(search.integrationId)),
    plannedStartDateTime: getDateFilterValue(
      transformCompactToDateFilter(search.plannedStartDateTime),
    ),
    plannedFinishDateTime: getDateFilterValue(
      transformCompactToDateFilter(search.plannedFinishDateTime),
    ),
  };
};

export const useInsightsFiltersAndOrder = () => {
  const search = Route.useSearch();
  const filters = parseInsightsFiltersFromSearch(search);
  const order = parseInsightsSortingFromSearch(search);

  return { filters, order };
};
